import React from 'react'
import {BrowserRouter as Router, Switch, Route} from "react-router-dom";
import {Home} from '../pages/Home'
import {TeamHistory} from '../pages/TeamHistory';
import {Aboutus} from '../pages/Aboutus';
import {NotFound} from '../components/NotFound';
import {Projects} from '../pages/Projects';
import {SansabotsFighterEdition} from '../pages/SansabotsFighterEdition';

export const AppRouter = () => {
    return (
        <Router>
            <div>
                <Switch>
                    <Route path="/" exact component = {Home} />
                    <Route path="/conocenos" component={Aboutus}/>
                    <Route path="/historico" component={TeamHistory}/>
                    <Route path="/inscribir-proyecto" component={Projects}/> 
                    <Route path="/sansabots" component={SansabotsFighterEdition}/>

                    <Route path = "/classroom" component={() => { 
                        window.location.href = 'https://moodle.fablab.usm.cl/'; 
                        return null;
                    }}/>

                    <Route path = "/portal" component={() => { 
                        window.location.href = 'https://portal.fablab.usm.cl/'; 
                        return null;
                    }}/> 

                    <Route component = {NotFound} />
                    
                </Switch>
            </div>
        </Router>
    )
}
